var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiLicesnseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.573,
    height: 22.143,
    viewBox: "0 0 21.573 22.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "si_licesnse",
    transform: "translate(-6.836 -0.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M381.792,314.039a.257.257,0,0,1-.181-.438l1.981-1.981a.257.257,0,0,1,.363.363l-1.981,1.981A.256.256,0,0,1,381.792,314.039Z",
    transform: "translate(-358.545 -297.974)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M361.777,338.324a.256.256,0,0,1-.181-.075l-.895-.895a.257.257,0,0,1,.363-.363l.895.9a.257.257,0,0,1-.182.438Z",
    transform: "translate(-338.531 -322.259)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M299.879,244.833a.257.257,0,0,1-.147-.046l-.878-.615-1.067.093a.257.257,0,0,1-.255-.147l-.453-.971-.971-.453a.257.257,0,0,1-.147-.255l.093-1.067-.615-.878a.256.256,0,0,1,0-.294l.615-.878-.093-1.067a.257.257,0,0,1,.147-.255l.971-.453.453-.971a.256.256,0,0,1,.255-.147l1.067.093.878-.615a.258.258,0,0,1,.294,0l.878.615,1.067-.093a.256.256,0,0,1,.255.147l.453.971.971.453a.257.257,0,0,1,.147.255l-.093,1.067.615.878a.258.258,0,0,1,0,.294l-.615.878.093,1.067a.257.257,0,0,1-.147.255l-.971.453-.453.971a.256.256,0,0,1-.255.147l-1.067-.093-.878.615A.258.258,0,0,1,299.879,244.833Zm-.955-1.181a.259.259,0,0,1,.147.046l.807.565.807-.565a.259.259,0,0,1,.169-.045l.981.086.416-.893a.256.256,0,0,1,.124-.124l.893-.416-.086-.982a.256.256,0,0,1,.045-.169l.565-.807-.565-.807a.259.259,0,0,1-.045-.169l.086-.982-.893-.416a.257.257,0,0,1-.124-.124l-.416-.893-.981.086a.259.259,0,0,1-.169-.046l-.807-.565-.807.565a.259.259,0,0,1-.17.046l-.982-.086-.416.893a.255.255,0,0,1-.124.124l-.893.416.086.982a.257.257,0,0,1-.046.169l-.565.807.565.807a.257.257,0,0,1,.046.169l-.086.982.893.416a.255.255,0,0,1,.124.124l.416.893.982-.086Z",
    transform: "translate(-276.09 -225.529)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M23.095,22.143H8.97a1.932,1.932,0,0,1-1.93-1.93V4.653a.256.256,0,1,1,.513,0v15.56A1.419,1.419,0,0,0,8.97,21.63H23.095a1.419,1.419,0,0,0,1.417-1.418V18.421a.256.256,0,0,1,.513,0v1.792a1.932,1.932,0,0,1-1.93,1.93Zm1.674-10.665a.257.257,0,0,1-.257-.257V2.18A1.419,1.419,0,0,0,23.095.763H10.906a.257.257,0,1,1,0-.513H23.095a1.932,1.932,0,0,1,1.93,1.93v9.041A.257.257,0,0,1,24.768,11.478Z",
    transform: "translate(-0.079 -0.003)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 12.246,
    transform: "translate(9.83 6.72)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 8.627,
    transform: "translate(9.83 16.72)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 8.627,
    transform: "translate(9.83 11.72)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1826",
    "data-name": "Ellipse 1826",
    cx: 1.429,
    cy: 1.429,
    r: 1.429,
    transform: "translate(7.794 1.264)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiLicesnseWhite);
export default __webpack_public_path__ + "static/media/si_licesnse_white.e04ff6e3a48f3a0deaf53c09e2e8a573.svg";
export { ForwardRef as ReactComponent };